import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let menuCache = null;

export function useOrderMenu() {
  const [menu, setMenu] = useState(menuCache);
  const [accepting, setAccepting] = useState(true);

  useEffect(() => {
    if (!menuCache) {
      axios
        .get(`${API}/menu/orderable`)
        .then(({ data }) => {
          menuCache = data;
          setMenu(data);
        })
        .catch(() => toast.error("Couldn't load the menu — please call (03) 5024 5570."));
    }
    axios.get(`${API}/settings`).then(({ data }) => setAccepting(data.accepting_orders)).catch(() => {});
  }, []);

  return { menu, accepting };
}
